export const SPLIT_TEST_NAME = {
  DIRECT_MERGE_PARTNER_BRANDED_SIGNUP_TEST:
    'direct_merge_partner_branded_signup_test',
  HIDE_TOP_BANNER_ON_MOBILE_STEP_0: 'hide_top_banner_on_mobile_step_0',
  MOCK_SPLIT_TEST: 'mock_split_test', // Example anonymous split test naming
  DE_MOBILE_SIGNUP_V1: 'de_mobile_signup_v1',
} as const;

type TSplitTests = {
  tests: {
    name: (typeof SPLIT_TEST_NAME)[keyof typeof SPLIT_TEST_NAME];
    /** List of branch names allowed.
     * Must have a length of 1 as only 50/50 split tests are allowed
     * Entry with index 0 must describe the "INCLUDE" branch
     */
    branches: Array<string>;
    /**
     * Default branch name to use for split test
     * Used when split-test value is below 0.5
     * Describes the "EXCLUDE" branch
     */
    defaultBranch: string;
    /**
     * Fraction that needs to be passed
     * in order for a customer to be included in the test
     * Defaults to 0.5
     */
    fraction: number;
  }[];
};

export const SPLIT_TESTS = {
  tests: [
    {
      name: SPLIT_TEST_NAME.MOCK_SPLIT_TEST,
      branches: ['INCLUDE'],
      defaultBranch: 'EXCLUDE',
      fraction: 0.5,
    },
    {
      name: SPLIT_TEST_NAME.HIDE_TOP_BANNER_ON_MOBILE_STEP_0,
      branches: ['INCLUDE'],
      defaultBranch: 'EXCLUDE',
      fraction: 0.5,
    },
    {
      name: SPLIT_TEST_NAME.DE_MOBILE_SIGNUP_V1,
      branches: ['INCLUDE'],
      defaultBranch: 'EXCLUDE',
      fraction: 0.5,
    },
  ],
} as const satisfies TSplitTests;
